/* eslint-disable */
// Generate a URL-safe slug from a project name.
export function projectSlug(p) {
  if (!p) return '';
  if (p.slug) return String(p.slug);
  const base = String(p.name || p.id || '').toLowerCase();
  return base
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function findProjectBySlug(slug) {
  const all = (window.LL_DATA && window.LL_DATA.projects) || [];
  return all.find(p => projectSlug(p) === slug);
}
